import { render, staticRenderFns } from "./Conveyancer.vue?vue&type=template&id=3c8cf65e"
import script from "./Conveyancer.vue?vue&type=script&lang=js"
export * from "./Conveyancer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports